var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      filter: "invert(1)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5455 0C13.2556 0 0 13.2556 0 29.5455V70.4545C0 86.7444 13.2556 100 29.5455 100H70.4545C86.7444 100 100 86.7444 100 70.4545V29.5455C100 13.2556 86.7444 0 70.4545 0H29.5455ZM29.5455 4.54545H70.4545C84.2875 4.54545 95.4545 15.7125 95.4545 29.5455V70.4545C95.4545 84.2875 84.2875 95.4545 70.4545 95.4545H29.5455C15.7125 95.4545 4.54545 84.2875 4.54545 70.4545V29.5455C4.54545 15.7125 15.7125 4.54545 29.5455 4.54545ZM77.2727 18.1818C76.0672 18.1818 74.911 18.6607 74.0586 19.5132C73.2062 20.3656 72.7273 21.5217 72.7273 22.7273C72.7273 23.9328 73.2062 25.089 74.0586 25.9414C74.911 26.7938 76.0672 27.2727 77.2727 27.2727C78.4783 27.2727 79.6344 26.7938 80.4869 25.9414C81.3393 25.089 81.8182 23.9328 81.8182 22.7273C81.8182 21.5217 81.3393 20.3656 80.4869 19.5132C79.6344 18.6607 78.4783 18.1818 77.2727 18.1818ZM50 25C36.2198 25 25 36.2198 25 50C25 63.7802 36.2198 75 50 75C63.7802 75 75 63.7802 75 50C75 36.2198 63.7802 25 50 25ZM50 29.5455C61.3237 29.5455 70.4545 38.6763 70.4545 50C70.4545 61.3237 61.3237 70.4545 50 70.4545C38.6763 70.4545 29.5455 61.3237 29.5455 50C29.5455 38.6763 38.6763 29.5455 50 29.5455Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_2439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.d2a43791a63b99fa09299d636d6eddbd.svg";
export { ForwardRef as ReactComponent };